import ThirdPartyLeakage from "./ThirdPartyLeakage";

export default ThirdPartyLeakage;
